$(function() {
    if($("#application_event_data_manager_rejects").length){
        $(".radio").click(check_application_datamanager_accepts);
        check_application_datamanager_accepts()
    }
    if($("#application_event_data_manager_accepts_and_sends_mail").length){
        $(".radio").click(check_application_datamanager_accepts_and_sends_mail);
        check_application_datamanager_accepts_and_sends_mail()
    }

});

function check_application_datamanager_accepts(){
    if ($("#application_event_data_manager_rejects")[0].checked == true) {
        $("div.application_comment").show()
    }else{
        $("div.application_comment").hide()
    }
}

function check_application_datamanager_accepts_and_sends_mail(){
    if ($("#application_event_data_manager_accepts_and_sends_mail")[0].checked == true) {
        $("div.application_categories").show();
    }else{
        $("div.application_categories").hide();
    }
}